<template>
  <el-form-item>
    <template #label>
      <span :style="{display: 'flex','align-items': 'center',color:'#344262','font-weight':context.formStyleSetting.PC.title}">
        {{element.label+suffix}}
       <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
    </template>
    <el-input :readonly="true" placeholder="请输入"></el-input>
  </el-form-item>
</template>

<script>

import FormElementTooltip from "@/components/common/formElementTooltip.vue";

export default {
  components: {FormElementTooltip},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    },
    parent: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    suffix() {
      return this.element.attrs.suffix ? `(${this.element.attrs.suffix})` : '';
    }
  },
  data() {
    return {
      data: this.element
    }
  },
  created() {
  }
}

</script>

<style scoped lang="scss">

</style>